<mat-dialog-content class="content-login">
    <!-- =====================================================
         LOGIN
         ===================================================== -->
    <div class="login-layout" *ngIf="!registerMode">
        <button class="login-close" mat-dialog-close type="button" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
        <div class="login-content">
            <img class="login-logo" src="../../../assets/logos-nina/nina-hd-black.png" alt="Nina Pastelería">
            <h2 class="login-title">
                Inicia sesión
            </h2>
            <p class="login-subtitle">
                Usa la misma cuenta de la app de Nina.
            </p>
            <form class="login-form" method="post" [formGroup]="loginForm" (ngSubmit)="login()">
                <!-- Correo / teléfono -->
                <div class="login-field">
                    <label for="login-phone">
                        CORREO O TELÉFONO
                    </label>
                    <mat-form-field class="login-input" appearance="outline">
                        <input id="login-phone" class="input-number-withoutcontrols" matInput formControlName="phone"
                            type="number">
                    </mat-form-field>
                </div>
                <!-- Contraseña -->
                <div class="login-field">
                    <label for="login-password">
                        CONTRASEÑA
                    </label>
                    <mat-form-field class="login-input" appearance="outline">
                        <input id="login-password" matInput formControlName="password" type="password">
                    </mat-form-field>
                </div>
                <!-- Iniciar sesión -->
                <button class="login-submit" mat-raised-button type="submit" [disabled]="!loginForm.valid">
                    Iniciar sesión
                </button>
                <button class="login-forgot-password" type="button" (click)="sendTemporalPassword()"
                    [disabled]="loginForm.value.phone?.length < 10">
                    ¿Olvidaste tu contraseña?
                </button>
            </form>
            <!-- Registro -->
            <p class="login-register-text">
                ¿No tienes una cuenta?
                <button type="button" class="login-register-link" (click)="changeRegister()">
                    Regístrate aquí
                </button>
            </p>
        </div>
    </div>
    <!-- =====================================================
         REGISTRO
         ===================================================== -->
    <div class="register-layout" *ngIf="registerMode">
        <button class="register-close" mat-dialog-close type="button" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
        <div class="register-content">
            <img class="register-logo" src="../../../assets/logos-nina/nina-hd-black.png" alt="Nina Pastelería">
            <h2 class="register-title">
                Crea tu cuenta
            </h2>
            <p class="register-subtitle">
                Ingresa tus datos para comenzar.
            </p>
            <form class="register-form" method="post" [formGroup]="registerForm" (ngSubmit)="register()">
                <!-- Nombre -->
                <div class="register-field">
                    <label>
                        NOMBRE(S)
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="names" type="text" placeholder="Nombre(s)">
                    </mat-form-field>
                    <mat-error *ngIf="names?.invalid && (names?.dirty || names?.touched)" class="register-error">
                        {{ getErrorMessage('names') }}
                    </mat-error>
                </div>
                <!-- Apellido paterno -->
                <div class="register-field">
                    <label>
                        APELLIDO PATERNO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="last_name" type="text" placeholder="Apellido Paterno">
                    </mat-form-field>
                    <mat-error *ngIf="last_name?.invalid && (last_name?.dirty || last_name?.touched)"
                        class="register-error">
                        {{ getErrorMessage('last_name') }}
                    </mat-error>
                </div>
                <!-- Apellido materno -->
                <div class="register-field">
                    <label>
                        APELLIDO MATERNO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="last_name2" type="text" placeholder="Apellido Materno">
                    </mat-form-field>
                    <mat-error *ngIf="last_name2?.invalid && (last_name2?.dirty || last_name2?.touched)"
                        class="register-error">
                        {{ getErrorMessage('last_name2') }}
                    </mat-error>
                </div>
                <!-- Género -->
                <div class="register-field">
                    <label>
                        GÉNERO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <mat-select formControlName="gender">
                            <mat-option value="">
                                Selecciona un género
                            </mat-option>
                            <mat-option value="M">
                                Masculino
                            </mat-option>
                            <mat-option value="F">
                                Femenino
                            </mat-option>
                            <mat-option value="O">
                                Otro
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- Otro género -->
                <div class="register-field" *ngIf="registerForm.get('gender')?.value === 'O'">
                    <label>
                        GÉNERO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="gender_value" type="text" placeholder="Especifica tu género">
                    </mat-form-field>
                    <mat-error *ngIf="gender_value?.invalid && (gender_value?.dirty || gender_value?.touched)"
                        class="register-error">
                        {{ getErrorMessage('gender_value') }}
                    </mat-error>
                </div>
                <!-- Fecha de nacimiento -->
                <div class="register-field">
                    <label>
                        FECHA DE NACIMIENTO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput readonly [matDatepicker]="picker" formControlName="birthdate" [max]="maxDate" placeholder="dd/mm/aaaa">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                        </mat-datepicker-toggle>

                        <mat-datepicker #picker>
                        </mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="birthdate?.invalid && (birthdate?.dirty || birthdate?.touched)"
                        class="register-error">
                        {{ getErrorMessage('birthdate') }}
                    </mat-error>
                </div>
                <!-- Correo -->
                <div class="register-field">
                    <label>
                        CORREO ELECTRÓNICO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="email" type="email" placeholder="Correo electrónico">
                    </mat-form-field>
                    <mat-error *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="register-error">
                        {{ getErrorMessage('email') }}
                    </mat-error>
                </div>
                <!-- Teléfono -->
                <div class="register-field">
                    <label>
                        TELÉFONO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="phone" type="number" placeholder="Teléfono">
                    </mat-form-field>
                    <mat-error *ngIf="phone?.invalid && (phone?.dirty || phone?.touched)" class="register-error">
                        {{ getErrorMessage('phone') }}
                    </mat-error>
                </div>
                <!-- Contraseña -->
                <div class="register-field">
                    <label>
                        CONTRASEÑA
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="password" type="password" placeholder="Contraseña">
                    </mat-form-field>
                    <mat-error *ngIf="password?.invalid && (password?.dirty || password?.touched)"
                        class="register-error">
                        {{ getErrorMessage('password') }}
                    </mat-error>
                </div>
                <!-- Código postal -->
                <div class="register-field">
                    <label>
                        CÓDIGO POSTAL
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput formControlName="main_zip_code" type="text" maxlength="5"
                            placeholder="Código Postal" (input)="searchDataZipCode()">
                    </mat-form-field>
                    <mat-error *ngIf="main_zip_code?.invalid && (main_zip_code?.dirty || main_zip_code?.touched)"
                        class="register-error">
                        {{ getErrorMessage('main_zip_code') }}
                    </mat-error>
                </div>
                <!-- Colonia -->
                <div class="register-field">
                    <label>
                        COLONIA
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <mat-select formControlName="locality_id" (selectionChange)="onSelectionLocality($event)">
                            <mat-option value="">
                                Selecciona una colonia
                            </mat-option>
                            <mat-option *ngFor="let localitie of dataLocalities | async" [value]="localitie.id">
                                {{ localitie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- Municipio -->
                <div class="register-field">
                    <label>
                        MUNICIPIO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput readonly formControlName="municipality" type="text" placeholder="Municipio">
                    </mat-form-field>
                </div>
                <!-- Estado -->
                <div class="register-field">
                    <label>
                        ESTADO
                    </label>
                    <mat-form-field class="register-input" appearance="outline">
                        <input matInput readonly formControlName="state" type="text" placeholder="Estado">
                    </mat-form-field>
                </div>
                <!-- IDs ocultos -->
                <input type="hidden" formControlName="municipality_id">
                <input type="hidden" formControlName="state_id">
                <!-- Términos -->
                <div class="register-check">
                    <mat-checkbox formControlName="terms_conditions">
                        He leído y acepto los términos y condiciones
                    </mat-checkbox>
                    <a href="https://ninapasteleria.com/tycnina.html" target="_blank" rel="noopener noreferrer">
                        Leer Términos y Condiciones
                    </a>
                </div>
                <!-- Aviso de privacidad -->
                <div class="register-check">
                    <mat-checkbox formControlName="privacy_notice">
                        Confirmo que he leído el aviso de privacidad
                    </mat-checkbox>
                    <a href="https://ninapasteleria.com/AvisoPrivacidad.html" target="_blank" rel="noopener noreferrer">
                        Leer Aviso de Privacidad
                    </a>
                </div>
                <!-- Registrar -->
                <button class="register-submit" mat-raised-button type="submit">
                    Crear cuenta
                </button>
                <!-- Regresar al login -->
                <button class="back-login" type="button" (click)="registerMode = false">
                    ¿Ya tienes una cuenta?
                    <strong>
                        Inicia sesión
                    </strong>
                </button>
            </form>
        </div>
    </div>
</mat-dialog-content>